export const manageLongString = (value: string, maxNumber: number) => {
    return value.length > maxNumber ? `${value.substring(0, maxNumber)}...` : value;
};
